import { render, staticRenderFns } from "./AddAutoAssignRule.vue?vue&type=template&id=fa62d0dc&"
import script from "./AddAutoAssignRule.vue?vue&type=script&lang=js&"
export * from "./AddAutoAssignRule.vue?vue&type=script&lang=js&"
import style0 from "./AddAutoAssignRule.vue?vue&type=style&index=0&id=fa62d0dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports